class CustomCart extends HTMLElement {

    itemCount = 0;

    constructor() {
        super();
        this.setupEventListeners();
        this.initRender();
    }

    setupEventListeners() {
        document.addEventListener(`CartUpdated`, () => {
            this.refreshCart();
        });
    }

    initRender() {
        this.innerHTML = `LOADING CART...`;
        this.style.fontSize = "14px";
        this.refreshCart();
    }

    async refreshCart() {
        let cartResponse  = await fetch(Shopify.routes.root+`cart.js`);
        let cart          = await cartResponse.json();
        if (!cart.token) return !!console.error("El carrito no parece correcto", cart);

        this.itemCount = 0;
        window.dispatchEvent(new CustomEvent('cart-item-count-updated', {detail: this.itemCount}));
        if (cart.items.length == 0) {
            this.innerHTML = `
                <div class="empty-cart-with-suggestions">
                    <div sytle="font-size: 14px;">
                        YOUR BAG IS EMPTY
                    </div>
                    <div>
                        ${document.getElementById(`cart-related-products`).innerHTML}
                    </div>
                </div>
                `;
            return;
        }
        
        this.innerHTML = ``;
        
        let cartWrapper = document.createElement("div");
            cartWrapper.classList.add("custom-cart-wrapper");
        
        let cartItemsContainer = document.createElement("div");
        cartItemsContainer.classList.add("custom-cart-items-container");
        cartWrapper.appendChild(cartItemsContainer)
        for (let item of cart.items ) { 
            this.itemCount += item.quantity;
            cartItemsContainer.appendChild(this.getCartItemNode(item, cart.currency));
        }
        window.dispatchEvent(new CustomEvent('cart-item-count-updated', {detail: this.itemCount}));

        let cartCheckoutButtonsWrapper = document.createElement("div");
        cartCheckoutButtonsWrapper.classList.add("custom-cart-checkout-buttons");
        // cartWrapper.appendChild(cartCheckoutButtonsWrapper)
        this.appendChild(cartWrapper);
        this.appendChild(cartCheckoutButtonsWrapper);
            let checkoutDetails = document.createElement("div");
            checkoutDetails.classList.add("checkout-details");
            checkoutDetails.innerHTML = `
                <div class="checkout-titles">
                    <div class="shipping-costs-title">SHIPPING COSTS</div>
                    <h4 class="total-costs-title">TOTAL</h4>
                    </div>
                <div class="checkout-values">
                    <div class="shipping-costs-value">free</div>
                    <h4 class="total-costs-value-wrapper">
                        <div class="total-costs-value">${cart.total_price/100} ${cart.currency}</div>
<div class="total-costs-desc">*VAT INCLUDED</div>                    </h4>
                </div>
            `;
            cartCheckoutButtonsWrapper.appendChild(checkoutDetails);
            let checkoutButton = document.createElement("div");
            checkoutButton.classList.add("checkout-buttons");
            checkoutButton.classList.add("none-magin-top");
            checkoutButton.innerHTML = `<a class="custom-form-button button-form-margin-top" href="/checkout">
                CHECKOUT
            </a>`;
            cartCheckoutButtonsWrapper.appendChild(checkoutButton);
    }

    getCartItemNode(item, currency) {
        let itemNode = document.createElement("div");
            itemNode.classList.add("cart-item-wrapper");
            
            let imageNode = document.createElement("div");
            imageNode.classList.add("cart-item-image-element");
            imageNode.style.backgroundImage = `URL(${item.image})`;
            itemNode.appendChild(imageNode);
            
            let textNode = document.createElement("div");
            textNode.classList.add("cart-item-text-element");
                
            let headerWrapper = document.createElement("div");
                headerWrapper.classList.add("cart-item-text-element-wrapper");
                    let titleDiv = document.createElement("div");
                        titleDiv.classList.add("cart-item-title");
                        titleDiv.innerHTML = `${item.product_title}`;
                    headerWrapper.appendChild(titleDiv);
                    let priceDiv = document.createElement("div");
                        priceDiv.classList.add("cart-item-price");
                        priceDiv.innerHTML = `${item.final_price/100} ${currency}`;
                    headerWrapper.appendChild(priceDiv);
                    let optionDiv = document.createElement("div");
                        optionDiv.classList.add("cart-item-option");
                        optionDiv.innerHTML = `${item.variant_title} EU`;
                    headerWrapper.appendChild(optionDiv);
                textNode.appendChild(headerWrapper);
                
                let buttonWrapper = document.createElement("div");
                buttonWrapper.classList.add("cart-item-button");
                    let updateQuantity = document.createElement("div");
                    updateQuantity.classList.add("cart-item-update-button");
                        let updateMinus = document.createElement("div");
                            updateMinus.classList.add("cart-item-update-minus");
                            updateMinus.innerHTML = `-`;
                            updateMinus.onclick = async () => {
                                this.changeQuantity(updateMinus, item, (item.quantity-1));
                            };
                            updateQuantity.appendChild(updateMinus);
                        let updateCurrent = document.createElement("div");
                            updateCurrent.classList.add("cart-item-update-current");
                            updateCurrent.innerHTML = `${item.quantity}`;
                            updateQuantity.appendChild(updateCurrent);
                        let updatePlus = document.createElement("div");
                            updatePlus.classList.add("cart-item-update-plus");
                            updatePlus.innerHTML = `+`;
                            updatePlus.onclick = async () => {
                                this.changeQuantity(updatePlus, item, (item.quantity+1));
                            };
                            updateQuantity.appendChild(updatePlus);
                    buttonWrapper.appendChild(updateQuantity);
                    let removeButton = document.createElement("div");
                    removeButton.classList.add("cart-item-remove");
                    removeButton.onmouseover = () => {
                        removeButton.style.color = "red";
                    };
                    removeButton.onmouseout = () => {
                        removeButton.style.color = ""; // Vuelve al color original
                    };
                    removeButton.innerHTML = `REMOVE`;
                    removeButton.onclick = async () => {
                        this.changeQuantity(removeButton, item, 0);
                    };
                    buttonWrapper.appendChild(removeButton);
                textNode.appendChild(buttonWrapper);
            itemNode.appendChild(textNode);
        return itemNode;
    }

    async addToCart(productId, variantId, quantity = 1) {
        let data = new FormData();
            data.set("id", variantId);
            data.set("product-id", productId);
            data.set("quantity", quantity);
            
        let response = await fetch(`/cart/add.js`, {
            method: "POST",
            body: data,
        });

        if (response.status === 200 && response.ok) {
            this.refreshCart();
            return true;
        } 
        return false;
    }

    async changeQuantity(element, item, quantity) {
        // element.innerHTML = `
        // <div class="loading-remove">
        //     <svg
        //         aria-hidden="true"
        //         focusable="false"
        //         class="spinner"
        //         viewBox="0 0 66 66"
        //         xmlns="http://www.w3.org/2000/svg"
        //     >
        //         <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        //     </svg>
        // </div>`;
        let data = new FormData();
            data.set("id", item.id);
            data.set("quantity", quantity);
            
        let response = await fetch(`/cart/change.js`, {
            method: "POST",
            body: data,
        });

        if (response.status === 200 && response.ok) {

        } 
        this.refreshCart();
    }
  
}

customElements.define('custom-cart', CustomCart);
  